import { WorkerTypes } from "@src/appV2/redesign/utils/WorkerTypes";
import { isDefined } from "@clipboard-health/util-ts";
import { first, get as _get, has, includes, isEmpty, isNil, isString } from "lodash";
import moment from "moment-timezone";
import qs from "query-string";

/**
 *
 * @param {Array} agentDocs Documents uploaded by agent
 * @param {Array} facilityDocs Required documents by facility
 */
const isAgentQualified = (agentDocs, facilityDocs) => {
  if (isEmpty(facilityDocs)) {
    return true;
  }
  if (isEmpty(agentDocs)) {
    return false;
  }

  const today = moment();

  const activeAgentDocs = agentDocs.filter(
    (document) => document.expires && today.isBefore(document.expires)
  );
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line no-param-reassign
  facilityDocs = facilityDocs.map((facDoc) => (facDoc._id ? facDoc._id : facDoc));

  return facilityDocs.every((facDoc) => {
    const isAvailableInAgent = activeAgentDocs.find(
      ({ _id, requirement }) => (requirement || _id) === facDoc
    );
    return isAvailableInAgent;
  });
};

const getLowerAssignmentRequirements = (qualification) => {
  switch (qualification) {
    case "NURSE":
      return [WorkerTypes.LVN, WorkerTypes.RN];

    case WorkerTypes.CNA:
      return [WorkerTypes.LVN, WorkerTypes.RN, WorkerTypes.CNA];

    case WorkerTypes.LVN:
      return [WorkerTypes.LVN, WorkerTypes.RN];

    case WorkerTypes.CAREGIVER:
      return [WorkerTypes.CAREGIVER, WorkerTypes.CNA];

    default:
      return [qualification];
  }
};

function parseUrl(location: { search?: string } | null | undefined): qs.ParsedQuery<string> {
  if (!isDefined(location?.search)) {
    return {};
  }
  return qs.parse(location.search);
}

function getQueryStringValue(parsed: qs.ParsedQuery<string>, key: string): string | undefined {
  const value = _get(parsed, key);
  if (isNil(value)) {
    return undefined;
  }
  const stringValue = Array.isArray(value) ? first(value) : value;
  return isString(stringValue) ? stringValue : String(stringValue);
}

function getQueryStringBoolean(parsed: qs.ParsedQuery<string>, key: string): boolean | undefined {
  // Check if key exists in the parsed object
  if (!has(parsed, key)) {
    return undefined;
  }

  const value = _get(parsed, key);
  const stringValue = Array.isArray(value) ? first(value) : value;

  // Handle case where parameter is present but has no value (e.g., ?flag)
  // qs.parse() returns empty string or null for parameters without values
  if (stringValue === "" || stringValue === null || value === null) {
    return true;
  }

  const stringified = String(stringValue);
  return includes(["true", "1"], stringified.toLowerCase())
    ? true
    : includes(["false", "0"], stringified.toLowerCase())
      ? false
      : undefined;
}

const onlyEnabledForSelectedAdmins = (email) => {
  const selectedAdminEmails = [
    "jesse.ferrigno@clipboardhealth.com",
    "wei@clipboardhealth.com",
    "jacki@clipboardhealth.com",
  ];
  if (selectedAdminEmails.includes(email)) {
    return true;
  }
  return false;
};

export {
  isAgentQualified,
  getLowerAssignmentRequirements,
  parseUrl,
  onlyEnabledForSelectedAdmins,
  getQueryStringValue,
  getQueryStringBoolean,
};
